import { DbState, defaultDbState } from 'contexts/db-state';
import { createContext } from 'react';
import { NavigationEntry, NavigationRoute } from 'services/types';

export type NavigationEntryContextData = {
    navigationEntries: DbState<NavigationEntry>
    navigationRoutes: DbState<NavigationRoute>
    isReady: () => boolean
    [key: string]: DbState<any> | (() => boolean)
}

export const defaultNavigationEntryContextData: NavigationEntryContextData = {
    navigationEntries: defaultDbState<NavigationEntry>(),
    navigationRoutes: defaultDbState<NavigationRoute>(),
    isReady: () => false
}

export const NavigationEntryContext = createContext<NavigationEntryContextData>(defaultNavigationEntryContextData)